var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5479 18.6286C27.5445 26.6644 19.4055 31.5548 11.3688 29.5509C3.33542 27.5476 -1.55501 19.4081 0.449228 11.373C2.45171 3.33629 10.5907 -1.55451 18.6249 0.448851C26.6611 2.45221 31.5512 10.5926 29.5476 18.6287L29.5478 18.6286H29.5479Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.52L11.1158 13.4042L11.1159 13.404L8.85599 11.144L15 5L21.146 11.1458L18.886 13.4058L15 9.52ZM7.26008 12.7396L5 15L7.25992 17.2596L9.52 14.9995L7.26008 12.7396ZM11.1159 16.5961L15 20.48L18.8859 16.5942L21.1471 18.853L21.146 18.8542L15 25L8.85601 18.856L8.85281 18.8528L11.1159 16.5961ZM22.7401 12.7409L20.48 15.001L22.74 17.2609L25 15.0008L22.7401 12.7409Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2922 14.9988H17.2932L15 12.7056L13.3051 14.4L13.1104 14.5948L12.7088 14.9965L12.7056 14.9996L12.7088 15.0029L15 17.2945L17.2933 15.0012L17.2944 15L17.2924 14.9988",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/bnbLogo.5291b528114b5ccde7311cdd8f5160fa.svg";
export { ForwardRef as ReactComponent };